import React from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import Login from "./components/Login";

import Landing from "./components/Landing";

import {

	ClientPortalEventsWidget,

	DEFAULT_CLIENT_PORTAL_WIDGET,

	FacilityContext,

	WidgetLayout,

	initializeFontAwesome,

} from "./widget-client";



initializeFontAwesome();



export default function App() {

	const [authenticated, setAuthenticated] = React.useState(false);

	const widget = DEFAULT_CLIENT_PORTAL_WIDGET;



	const logout = async () => {

		await fetch("login/Logout");

		setAuthenticated(false);

		window.location.href = "/";

	};



	React.useEffect(() => {

		fetch("login/IsLoggedIn")

			.then((dt) => dt.json())

			.then((dt) => {

				if (dt) setAuthenticated(true);

			});

	}, []);



	if (!authenticated) {

		return (

			<Switch>

				<Route path="/home" render={() => <Login setAuthenticated={() => setAuthenticated(true)} />} />

				<Route render={() => <Login setAuthenticated={() => setAuthenticated(true)} />} />

			</Switch>

		);

	}



	return (

		<Switch>

			<Route path="/landing" component={Landing} />

			<Route

				render={() => (

					<FacilityContext.Provider value="">

						<WidgetLayout navText={widget.display} onLogout={logout}>

							<Switch>

								<Route exact path="/" render={() => <Redirect to={widget.path} />} />

								<Route exact path="/home" render={() => <Redirect to={widget.path} />} />

								<Route exact path={widget.path} component={ClientPortalEventsWidget} />

								<Route render={() => <Redirect to={widget.path} />} />

							</Switch>

						</WidgetLayout>

					</FacilityContext.Provider>

				)}

			/>

		</Switch>

	);

}

